class CountrySelector extends HTMLElement {
    connectedCallback() {
        this.trigger = this.querySelector("[data-country-selector-open]")
        this.closeButton = this.querySelector("[data-country-selector-close]")
        this.overlay = this.querySelector("[data-country-selector-overlay]")
        this.drawer = this.querySelector("[data-country-selector-drawer]")
        this.search = this.querySelector("[data-country-selector-search]")
        this.list = this.querySelector("[data-country-selector-list]")
        this.emptyState = this.querySelector("[data-country-selector-empty]")
        this.items = Array.from(this.querySelectorAll("[data-country-search]"))

        if (!this.trigger || !this.drawer) return

        this.trigger.addEventListener("click", () => this.toggleDrawer(true))
        this.closeButton?.addEventListener("click", () =>
            this.toggleDrawer(false)
        )
        this.overlay?.addEventListener("click", () => this.toggleDrawer(false))
        this.search?.addEventListener("input", () => this.filterCountries())
        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape" && this.isOpen) this.toggleDrawer(false)
        })
    }

    get isOpen() {
        return this.drawer.classList.contains("country-open")
    }

    toggleDrawer(isOpen) {
        this.drawer.classList.toggle("country-open", isOpen)
        this.overlay?.classList.toggle("active", isOpen)
        this.trigger.setAttribute("aria-expanded", String(isOpen))

        if (!isOpen) return

        // Match the filter drawer: pin the header so it can't slide over the panel.
        const header = document.querySelector("header-487")
        if (header) {
            header.classList.add("fixed", "top-0")
            header.style.transform = "translateY(0)"
        }

        // this.search?.focus()
    }

    filterCountries() {
        const query = this.search.value.trim().toLowerCase()
        let visible = 0

        this.items.forEach((item) => {
            const match =
                !query ||
                (item.dataset.countrySearch || "").indexOf(query) !== -1
            item.hidden = !match
            if (match) visible++
        })

        if (this.emptyState) this.emptyState.hidden = visible > 0
    }
}

customElements.define("country-selector", CountrySelector)
